module.exports = __webpack_public_path__ + "img/q31-5.05bdfb7d.jpg";